import { render, staticRenderFns } from "./VMilestone.vue?vue&type=template&id=5e767940&"
import script from "./VMilestone.vue?vue&type=script&lang=js&"
export * from "./VMilestone.vue?vue&type=script&lang=js&"
import style0 from "./VMilestone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports